import { connector } from 'utils/graphql';
import { useAuth } from 'providers/auth';

import React, {
  createContext,
  useContext,
  useState,
  useEffect
} from 'react';

// import { debounce } from 'utils/functions';

const UserSettingsContext = createContext();

function UserSettingsProvider ({ children }) {

  const {
    data: loggedUserData,
    signOut
  } = useAuth();

  // whatever you set here as default, will be used in both server side and client as well
  const [providerData, setProviderData] = useState({
    ready: false,
    data : {
      // add default data to your provider here
      wallpaper: '9',
      theme: 'dark',
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
    }}
  );

  // you can get extra data asynchronously if needed
  // this will only affect the client side
  async function fetchProviderData () {

    let { data: globalUserSettings, error:settingsError } = await connector
      .from('global_user_settings')
      .select(`*`)
      .not('current_scope', 'is', null)
      .order('created_at', { ascending: false })
      .limit(1);
    // console.log(await connector.from('global_user_settings').select(`*,
    //   tenants!products(*)
    // `));
    // console.log(await connector.from('global_user_settings').select(`*,
    //   tenants!products(*)
    // `));

    if (settingsError) {
      throw new Error(settingsError);
    }
    // debugger;
    // const {data:qrData, error} = await connector.query(gql`
    // query ($userId: UUID) {
    //   orgsCollection (filter: {creator: { eq: $userId }}) {
    //     edges {
    //       node {
    //         id,
    //         name,
    //         creator
    //       }
    //     }
    //   }
    // }
    // `, { userId: loggedUserData.user.id });
    // console.log(qrData, error);
    // debugger;

    // const {
    //   data: { global_user_settingsCollection:globalUserSettings }
    // }  = await doQuery(queries?.globalUserSettings);
    // debugger;
    let { data:userOrgs, error:orgError } = await connector
      .from('orgs')
      .select('created_at')
      .eq('creator', loggedUserData.user.id);
      // .limit(1);

    if (orgError) {
      throw new Error(orgError);
    }
    // const {
    //   data: { orgsCollection:userOrgs }
    // }  = await doQuery(queries?.myOrgsCollection, {
    //   userId: loggedUserData.user.id
    // });

    const settings = {
      ...(globalUserSettings[0] || { })
    };

    let { data:tData, error:tError } = await connector
      .from('tenant_user_settings')
      .select(`*`)
      .limit(1);

    if (tError) {
      throw new Error(tError);
    }

    settings.tenantSettings = tData[0] || {
      wallpaper: 9
    };

    if (!userOrgs.length) {
      // first time the user is here!
      setProviderData({
        ...providerData,
        data : {
          ...(providerData?.data || {}),
          showWelcome: true,
          user_id: loggedUserData?.user?.id,
          ...settings
        },
        ready: false,
      });
    } else {
      setProviderData({
        ...providerData,
        data : {
          ...(providerData?.data || {}),
          showWelcome: false,
          user_id: loggedUserData.user.id,
          ...settings,
        },
        ready: true,
      });
    }
  }

  // when user IS authenticated, we go for their settings
  useEffect(() => {
    if (loggedUserData.isAuthenticated) {
      fetchProviderData()
        .catch((err) => {
          console.error(err);
          alert(`Sign error code 9568`);
          signOut();
          setTimeout(_=>{
            location.reload();
          }, 500);
          console.log(err);
        });
    }
  }, [loggedUserData, providerData?.data?.current_scope]);

  useEffect(() => {
    const disableAnimations = providerData?.data?.reducedMotion;
    document.body.dataset.reducedMotion = disableAnimations ? 1 : 0;
  }, [providerData?.data?.reducedMotion]);

  useEffect(() => {
    const largerFonts = providerData?.data?.largerFonts;
    document.body.dataset.largerFonts = largerFonts ? 1 : 0;
  }, [providerData?.data?.largerFonts]);

  useEffect(() => {
    document.body.dataset.theme = providerData?.data?.theme;
  }, [providerData?.data?.theme]);

  useEffect(() => {
    const largerFonts = providerData?.data?.largerFonts;
    document.body.dataset.largerFonts = largerFonts ? 1 : 0;
  }, [providerData?.data?.largerFonts]);

  useEffect(() => {
    document.querySelector('html').setAttribute(
      'dir',
      providerData?.data?.textDirection
    );
  }, [providerData?.data?.textDirection]);

  useEffect(() => {
    const disableBlur = providerData?.data?.reducedBlur;
    document.body.dataset.reducedBlur = disableBlur ? 1 : 0;
  }, [providerData?.data?.reducedBlur]);

  const value = {
    ...providerData,
    fetchData : fetchProviderData,
    setData (key, value) {
      // let newData = {};

      // newData = { ...providerData };
      // newData.data = newData.data || {};

      // if (typeof key === 'object' && value === undefined) {
      //   newData.data = {
      //     ...newData.data,
      //     ...key
      //   };
      // } else {
      //   newData.data = {
      //     ...newData.data,
      //     [key]: value
      //   };
      // }

      setProviderData(currentData => {
        let newData = {...currentData};
        newData.data = newData.data || {};

        if (typeof key === 'object' && value === undefined) {
          newData.data = {
            ...newData.data,
            ...key
          };
        } else {
          newData.data = {
            ...newData.data,
            [key]: value
          };
        }

        sendUserSettings(newData);
        return newData;
      });

      // setProviderData(newData);
      // sendUserSettings(newData);
    }
  };

  const sendUserSettings = async (newData) => {
    const {
      showWelcome,
      ...newProviderData
    } = newData.data; // this is only used in the browser

    // TODO: fix it: the probable fix for issue #74 must be around here...

    const tenantSettings = newProviderData?.tenantSettings || {};
    delete newProviderData?.tenantSettings;

    const { error } = await connector
      .from('global_user_settings')
      .upsert({
        id: newProviderData.id || undefined,
        user_id: loggedUserData.user.id,
        ...newProviderData
      })
      .select();

    const { error: tError } = await connector
      .from('tenant_user_settings')
      .upsert({
        user_id: loggedUserData.user.id,
        ...tenantSettings
      })
      .select();

    if (error || tError) {
      // TODO: deal with errors here
      console.error(33445, error);
    }// else {
    // debugger; console.log(data);
    // if (data && data[0]) {
    //   const { id, user_id, ...customizations } = data[0];
    //   setProviderData({
    //     ...providerData,
    //     data: {
    //       ...(providerData?.data),
    //       showWelcome,
    //       id,
    //       user_id,
    //       ...customizations
    //     }
    //   });
    // }
    // }
    // await doMutation(upsertUserSettings, newData);
  };//, 500);

  return (
    <UserSettingsContext.Provider value={value}>

      {children}

    </UserSettingsContext.Provider>
  );
}

// this allows you to use it as a simpler hook
function useUserSettings () {
  const context = useContext(UserSettingsContext);
  if (context === undefined) {
    throw new Error(`useUserSettings must be used within a UserSettingsProvider`);
  }

  return context;
}

export {
  UserSettingsProvider,
  UserSettingsContext,
  useUserSettings,
};
